import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/msal';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';

// MSAL must finish initialising before any component asks it for an account.
await msalInstance.initialize();

// The redirect returns here with the result in the URL. This must run before
// React renders, or the app decides it is signed out while the response is
// still sitting unprocessed.
const redirectResult = await msalInstance.handleRedirectPromise();
if (redirectResult?.account) {
  msalInstance.setActiveAccount(redirectResult.account);
}

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0 && accounts[0]) {
  msalInstance.setActiveAccount(accounts[0]);
}

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
    </ErrorBoundary>
  </StrictMode>,
);
